import React from 'react';
import { Typography } from '@mui/material';
import { getFormattedTimeDifferenceComparedToTimeNow } from 'services/utils/dateCalculations';
import { useTranslation } from 'services/localization/useTranslation';

interface OwnProps {
	rentalCreateTime: string | undefined;
}

type Props = OwnProps;

export const RentalCardWaitTime = ({ ...props }: Props) => {
	const { t } = useTranslation();
	const rentalCreateTime = props.rentalCreateTime;
	const waitTimeFromCustomerCheckIn = rentalCreateTime
		? getFormattedTimeDifferenceComparedToTimeNow(rentalCreateTime)
		: '';

	return (
		<React.Fragment>
			<Typography variant="body2" color="textSecondary" align="right">
				{t('rentalCard.waitingTime', 'Waiting time')}
			</Typography>
			<Typography variant="body1" align="right">
				{waitTimeFromCustomerCheckIn}
			</Typography>
		</React.Fragment>
	);
};

export default RentalCardWaitTime;
